<template>
  <div class="sub-account">
    <rCenterHeader>
      <div
        slot="search"
        class="common-hover common-flex sub-account-details common-align-center"
        @click="details"
      >
        <div class="iconfont iconxiangqing"></div>
        <div>{{ $t("customer.allocationDetails") }}</div>
      </div>
    </rCenterHeader>
    <div class="common-flex common-flex-end" style="width:1420px;margin:0 auto;background:#fff;padding:10px 30px 0 0">
    <form>
      <Input
         @keydown.enter.native.prevent="search"
        size="large"
        search
        v-model="params.username"
        :placeholder="$t('fabricLibrary.search')"
        style="width: 380px"
      >
        <Icon type="ios-search" slot="suffix" />
      </Input>
    </form>
    </div>
    <div class="sub-account-list common-flex common-flex-wrap">
      <div class="all-account">
        <div class="distributable-amount">
          {{ $t("customer.distributableAmount") }}
        </div>
        <div class="all-price" v-if="userDetails.self">{{userDetails.self.balance}}</div>
        <div
          class="common-flex common-align-center common-justify-between"
          style="margin: 0 0 10px 25px; width: 223px"
        >
          <div class="all-subtitle">{{ $t("customer.allocatedAmount") }}</div>
          <div class="sub-price" v-if="userDetails.self">{{userDetails.self.allocatedAmount}}</div>
        </div>
        <div
          class="common-flex common-align-center common-justify-between"
          style="margin: 0 0 10px 25px; width: 223px"
        >
          <div class="all-subtitle">{{ $t("customer.amountUsed") }}</div>
          <div class="sub-price" v-if="userDetails.self">{{userDetails.self.amountUsed}}</div>
        </div>
      </div>
      <rSubAccount v-for="(item,index) in userDetails.children" :config="item" :key="index" @update="updateList" @edit="edit"></rSubAccount>
    </div>
    <rAccountModal
      :accountShow="accountShow"
      @handlerAccountShow="handlerAccountShow"
      :editSub="editSub"
      @sumitSub="sumitSub"
    ></rAccountModal>
  </div>
</template>

<script>
import rCenterHeader from "../../components/r-center-header";
import rSubAccount from "../../components/r-sub-account";
import rAccountModal from "../../components/r-account-modal";
import {mapActions} from 'vuex'
export default {
  name: "sub-account",
  data() {
    return {
      editSub:'',//编辑的数据
      params:{
        username:""
      },
      // 详情
      userDetails:"",
      // 编辑弹框是否显示
      accountShow: false,
      // 头部面包屑
      headerMenu: [
        {
          name: this.$t("customer.crumbs.individualAccount"),
          to: "./user",
        },
        {
          name: this.$t("customer.crumbs.subAccount"),
        },
      ],
    };
  },
  mounted(){
    this.cashDetails()
  },
  methods: {
    ...mapActions([
      'cashDetailsAction',//子账号列表
    ]),
    updateList(){
    this.cashDetails()
      
    },
    // 子账号列表
    cashDetails(){
      this.cashDetailsAction(this.params).then(res=>{
        this.userDetails = res.data
      })
    },
    // 详情
    details() {
      this.$router.push("./allocationDetails");
    },
    //   新增预约
    edit(e) {
      console.log('editSub',e,this.userDetails.self)
      this.editSub = Object.assign(this.userDetails.self,e)
      this.accountShow = true;
    },
    // 隐藏预约
    handlerAccountShow() {
      this.accountShow = false;
    },
    // 提交成功书信页面
    sumitSub() {
      this.accountShow = false;
      this.cashDetails()
    },
    // 搜索
    search() {
      this.cashDetails()
    },
  },
  components: {
    rCenterHeader,
    rSubAccount,
    rAccountModal,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.sub-account {
  .sub-account-details {
    font-size: 14px;
    font-family: Roboto;
    font-weight: 700;
    text-align: left;
    color: #0a4dcc;
    line-height: 16px;
    .iconxiangqing {
      font-size: 12px;
      margin-right: 11px;
    }
  }
  .sub-account-list {
    width: 1420px;
    margin: 0 auto;
    min-height: 100vh;
    background: #fff;
    padding: 20px;
    margin-bottom: 10px;
    .all-account {
      width: 325px;
      height: 219px;
      background-image: url("../../assets/images/zi-bg.png");
      background-size: 325px 219px;
      margin: 0 10px;
      .distributable-amount {
        opacity: 0.6;
        font-size: 14px;
        font-family: Roboto;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        line-height: 16px;
        margin-bottom: 10px;
        margin: 40px 0 10px 25px;
      }
      .all-price {
        font-size: 39px;
        font-family: Roboto;
        font-weight: 700;
        text-align: left;
        color: #ffffff;
        line-height: 46px;
        margin: 0 0 40px 25px;
      }
      .all-subtitle {
        opacity: 0.6;
        font-size: 14px;
        font-family: Roboto;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        line-height: 16px;
      }
      .sub-price {
        opacity: 1;
        font-size: 14px;
        font-family: Roboto;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        line-height: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/subAccount/subAccount.vue